<div class="cdp-navbar-clock" [class.hidden-clock]="!showingClock">
    <div class="clock-inner">
        <div class="time-section" title="Local time: {{ localTimeLong }}">
            <span class="icon-left icon-clock"></span>
            <span>{{ localTime }}</span>
        </div>
        <div class="time-section" title="UTC time: {{ utcTimeLong }}">
            <span>{{ utcTime }}</span>
            <span class="utc-offset" [title]="offsetTooltip">{{ timeOffset }}</span>
        </div>
    </div>
    <div
        class="clock-trigger"
        (click)="clockService.hideClock()"
        yAlign="below"
        hcTooltip="Hide clock. (You can reopen later from the user menu.)"
    >
        <span class="icon-chev-up"></span>
    </div>
</div>
